import * as React from 'react'
import * as Redux from 'react-redux'
import { useLocation } from 'react-router'

import * as layout from '@owl-nest/layout'

import * as projectModel from '../../../models/project'
import { type RootState } from '../../../../reducers'

export function PreviewBar(): React.ReactElement<unknown> {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  const { search } = useLocation()
  const urlSearchParams = new URLSearchParams(search)
  const previousEditionPath = urlSearchParams.get('prev')

  return <layout.PreviewBar previousEditionPath={previousEditionPath ?? `/${project.slug}/`} />
}
